import ts from 'typescript';
import { NodeCompiler } from '../NodeCompiler';
export class PartiallyEmittedExpressionCompiler extends NodeCompiler {
    constructor() {
        super(...arguments);
        this.kind = ts.SyntaxKind.PartiallyEmittedExpression;
    }
    visitNode(_sb, _expr, _options) {
    }
}

//# sourceMappingURL=PartiallyEmittedExpressionCompiler.js.map
